import {
	get,
	post
} from './http'

import axios from 'axios';

export default {
	GetCurrencyList() {
		return get('api/BaseData/GetCurrencyList', {});
	},

	GetPaymentList() {
		return get('api/BaseData/GetPaymentList', {});
	},
	/**
	 * @description 获取采购分类
	 * @param {Object} token 用户令牌
	 */
	GetPurchaseClass(token) {
		return get('api/BaseData/GetPurchaseClass', {
			token
		})
	},

	GetAreaList() {
		return get('api/BaseData/GetAreaList', {})
	},

	CreateOrEditAreaInfo(token, data) {
		return post('api/BaseData/CreateOrEditAreaInfo', {
			token: token,
			data: data,
		});
	},

	GetUnitList() {
		return get('api/BaseData/GetUnitList', {});
	},

	CreateUnit(token, data) {
		return post('api/BaseData/CreateUnit', {
			token,
			data
		});
	},

	GetApprovalLevelList(token, filter) {
		return get('api/Approval/GetApprovalLevelList', {
			token,
			filter
		});
	},

	SetApprovalLevel(token, data) {
		return post('api/Approval/SetApprovalLevel', {
			token,
			data
		});
	},

	SetApprovalLevelGroup(token, data) {
		return post('api/Approval/SetApprovalLevelGroup', {
			token,
			data
		});
	},

	SetApprovalGroupMember(token, data) {
		return post('api/Approval/SetApprovalGroupMember', {
			token,
			data
		});
	},

	SetApprovalGroupDepart(token, data) {
		return post('api/Approval/SetApprovalGroupDepart', {
			token,
			data
		});
	},

	CreateOrEditBaseData(token, data) {
		return post('api/BaseData/CreateOrEditBaseData', {
			token,
			data
		});
	},

	GetBaseDataList(token, type, page = 1, recordCount = 50) {
		return get('api/BaseData/GetBaseDataList', {
			token,
			type,
			page,
			recordCount
		})
	},

	CreateOrEditPaymentTerm(token, data) {
		return post('api/BaseData/CreateOrEditPaymentTerm', {
			token,
			data
		})
	},

	SyncClientMenu(token, data) {
		return post('api/BaseData/SyncClientMenu', {
			token,
			data
		})
	},

	GetMenuList(token, isMobile = 0) {
		return get('api/BaseData/GetMenuList', {
			token,
			isMobile
		})
	},

	SetGroupMenu(token, data) {
		return post('api/System/SetGroupMenu', {
			token,
			data
		})
	},

	GetGroupMenu(token, groupId, tree = 0) {
		return get('api/System/GetGroupMenu', {
			token,
			groupId,
			tree
		})
	},
	
	SendEmail(token, data) {
		return post('api/Email/SendEmail', {
			token,
			data,
		})
	},
	
	SetAttachmentState(token, data) {
		return post('api/Utils/SetAttachmentState', {
			token,
			data,
		})
	},
}



// WEBPACK FOOTER //
// ./src/request/baseDataApi.js